const apiRoutes = {
  user: {
    profile: '/api/v3/private/user/self',
    refreshToken: '/api/v3/public/user/token/refresh',
    kyc: '/api/v3/private/ams/user-kyc',
  },
  place: {
    autocomplete: '/dplaces/web/v2/autocomplete',
    autocomplete_google: '/gplaces/web/v2/autocomplete',
    geocode_reverse: '/wgeo/v2/reverse?',
    detail: 'gplaces/web/v2/detail',
    saved_places: '/api/v3/private/user/user-place',
    hubs: '/api/v3/public/ams/hub',
  },
  services: {
    estimate_fee: '/api/v3/public/ams/estimate',
    service_models: '/api/v3/public/ams/service-models',
    available_cities: '/api/v3/public/ams/service-models/cities',
    detail: (id: string) => `/api/v3/public/ams/service-models/${id}`,
    assets: '/api/v3/public/ams/assets',
    cancel_reason: 'api/v3/private/ams/dropdown-items/cancel-reason',
  },
  promotion: {
    list: '/api/v3/public/ams/promo-code',
    detail: '/api/v3/private/promotion',
  },
  payment: {
    list: '/api/v3/private/payment/customers/methods/ev-rental',
    pay: '/api/v3/private/payment/pay/ev-rental',
    source_cards: '/api/v3/private/payment/sources/cards',
  },
  contract: {
    create: '/api/v3/private/ams/contracts',
    list: '/api/v3/private/ams/contracts',
    contractById: (id: string) => `/api/v3/private/ams/contracts/${id}`,
    cancel: (id: string) => `/api/v3/private/ams/contracts/${id}/cancel`,
    updateById: (id: string) => `/api/v3/private/ams/contracts/${id}`,

    estimateChange: (id: string) =>
      `/api/v3/private/ams/contracts/${id}/estimate-changes`,
  },
  cms: {
    helpCenter: '/api/help-centers?populate[items][populate]=%2A',
    homeBanner: {
      list: '/api/home-banner?populate[items][populate]=%2A',
    },
  },
  assets: {
    uploadImages: '/api/v3/private/assets/images/upload',
  },
};

export default apiRoutes;
